<template>
  <div class="payFeeList">
    <div class="paySettleMain">
      <template v-if="tableData.length > 0">
        <el-table
          :data="tableData"
          ref="multipleTable"
          :cell-class-name="tableRowClassName"
          class="myMemTable"
          style="width: 100%"
          :header-cell-style="{background:'#EFF1F5'}"
        >
          <el-table-column align="center" prop="staffId" label="员工编号"></el-table-column>
          <el-table-column align="center" prop="staffName" label="姓名"></el-table-column>
          <el-table-column align="center" prop="staffPhone" label="手机号"></el-table-column>
          <el-table-column align="center" prop="postId" label="岗位">
            <template slot-scope="scope">
              {{scope.row.postId | filterPostId(infolist.postIdData) | filterRow}}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="status" label="状态">
            <template slot-scope="scope">
                {{scope.row.status | filterStatus}}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="maxDiscount" label="最大折扣">
              <template slot-scope="scope">
                  {{scope.row.maxDiscount == 0 ? '无': scope.row.maxDiscount+'折'}}
              </template>
          </el-table-column>
          <el-table-column align="center" prop="maxPreferential" label="最大优惠金额">
              <template slot-scope="scope">
                  {{scope.row.maxPreferential == 0 ? '无': scope.row.maxPreferential}}
              </template>
          </el-table-column>
          <el-table-column align="center" prop="maxMaling" label="最大抹零金额">
              <template slot-scope="scope">
                  {{scope.row.maxMaling == 0 ? '无': scope.row.maxMaling}}
              </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="editPro(scope.row)">修改权限</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-else>
        <div class="emptys">查不到结算权限信息！再核对一下试试</div>
      </template>
    </div>

    <el-dialog title="修改权限" :visible.sync="dialogTableVisible" :center="true" :width="$store.state.userInfo.brandId == 1? '580px':'700px'">
      <!-- 修改结算权限信息 -->
      <editSettle @closeDialog="closeDialog" :cueRowData='cueRowData' :openFlag="openFlag"/>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import editSettle from "./editSettle";
import { queryAllSettlementList } from "@/api";
import infolist from '@/assets/js/info'
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  components: {
    editSettle
  },
  data() {
    return {
      tableData: [],
      form: {},
      infolist:infolist,
      fullscreenLoading: false,
      dialogTableVisible: false, //修改结算权限信息弹窗
      cueRowData:'',//当前选中的数据
      openFlag:false,
    };
  },
  created() {
    this.search();
  },
  methods: {
    async search(val) {
      this.fullscreenLoading = true;
      let res = await queryAllSettlementList({});
      this.fullscreenLoading = false;
      if (res.data.length == 0) {
        this.mySearchflag = true;
      }
      this.tableData = res.data;
    },
    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      //把每一行的索引放进row
      row.index = rowIndex;
      if (rowIndex % 2 == 1) {
        return "highLight";
      }
      return "";
    },
    editPro(row) {
      // 修改
      this.dialogTableVisible = true;
      this.cueRowData = row;
      this.openFlag = false;
    },
    closeDialog(val) {
      this.dialogTableVisible = val;
      this.openFlag = true;
      this.search();
    }
  }
};
</script>
<style lang="less" scoped>
.paySettleMain {
  padding: 25px 0;
  .tips {
    color: #f83b56;
    text-align: left;
  }
  .myMemTable {
    margin-top: 25px;
    border: 1px solid #d5d9e3;
    .el-button--mini {
      padding: 8px;
      font-weight: bold;
    }
    .el-button + .el-button {
      margin-left: 0;
    }
    .tableGoods {
      .myTitle {
        width: 100%;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .defaults,
  .emptys {
    height: 600px;
    background: url(../../assets/images/store/img_vip_inquire.png) no-repeat
      center;
    text-align: center;
    font-size: 15px;
    color: #666;
    padding-top: 450px;
  }
  .emptys {
    background: url(../../assets/images/store/img_vip_none.png) no-repeat center;
  }
}
</style>
<style lang="less">
.payFeeList {
  .el-dialog__title {
    font-weight: bold;
  }
}
.myMemTable {
  .mySortTab {
    padding: 0;
    .el-form-item__content {
      .el-input {
        width: 60px;
        .el-input__inner {
          text-align: center;
        }
      }
      .el-form-item__error {
        position: relative;
        white-space: nowrap;
      }
    }
  }
  .el-input__inner,
  .el-input__inner:focus {
    border: 1px solide #f83b56;
    border-color: #f83b56;
  }
  .el-table__header {
    background: rgb(239, 241, 245);
  }
  .highLight {
    background: #eff1f5;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/basicDataCenter/payAndAuthority.vue